module.exports = __webpack_public_path__ + "img/noises-29.bc83ee31.jpg";